/* ===================================================================
   LINNEA — product-template.js
   =================================================================== */

// ── ANNOUNCE BAR ROTATION ──
(function () {
  const msgs = [
    'Free UK delivery on orders over £50',
    'Ships in 1 to 2 days, fully tracked',
    'Easy 30-day returns. Nothing extra to pay on arrival'
  ];
  let idx = 0;
  const ann = document.getElementById('ann');
  if (!ann) return;
  setInterval(() => {
    ann.style.opacity = '0';
    setTimeout(() => {
      ann.textContent = msgs[++idx % msgs.length];
      ann.style.opacity = '1';
    }, 280);
  }, 4000);
})();

// ── TABS ──
function setTab(btn) {
  const bar = btn.closest('.tab-bar');
  bar.querySelectorAll('.tab').forEach(t => t.classList.remove('active'));
  btn.classList.add('active');
  const section = btn.closest('.tabs-section');
  section.querySelectorAll('.tab-panel').forEach(p => p.classList.remove('active'));
  document.getElementById(btn.dataset.tab).classList.add('active');
}

// ── THUMBNAIL SWAP ──
document.querySelectorAll('.thumb').forEach(thumb => {
  thumb.addEventListener('click', () => {
    document.querySelectorAll('.thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
    const mainImg = document.getElementById('main-img');
    if (mainImg && thumb.dataset.src) {
      mainImg.src = thumb.dataset.src;
      if (thumb.dataset.alt) mainImg.alt = thumb.dataset.alt;
    }
  });
});

// ── VARIANT SELECTOR ──
function setVariant(el) {
  document.querySelectorAll('.size-pill').forEach(p => p.classList.remove('active'));
  el.classList.add('active');
  const price = el.dataset.price;
  const variantId = el.dataset.variantId;
  const sizeLabel = el.dataset.sizeLabel;
  const priceEl = document.getElementById('price');
  if (priceEl && price) priceEl.textContent = price;
  const sizeLabelEl = document.getElementById('size-label');
  if (sizeLabelEl && sizeLabel) sizeLabelEl.textContent = '· ' + sizeLabel;
  const sp = document.getElementById('sticky-price');
  if (sp && price) sp.textContent = price;
  const variantInput = document.getElementById('variant-id');
  if (variantInput && variantId) variantInput.value = variantId;
  const isAvailable = el.dataset.available === 'true';
  const atcBtn = document.querySelector('.atc-btn');
  if (atcBtn) {
    atcBtn.disabled = !isAvailable;
    atcBtn.textContent = isAvailable ? 'Add to cart' : 'Out of stock';
  }
  if (variantId) {
    const url = new URL(window.location);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url);
  }
}

// ── VARIANT SELECT DROPDOWN ──
function setVariantFromSelect(sel) {
  const opt = sel.options[sel.selectedIndex];
  const sizeLabelEl = document.getElementById('size-label');
  if (sizeLabelEl && opt.dataset.sizeLabel) sizeLabelEl.textContent = '· ' + opt.dataset.sizeLabel;
  const priceEl = document.getElementById('price');
  if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
  const sp = document.getElementById('sticky-price');
  if (sp && opt.dataset.price) sp.textContent = opt.dataset.price;
  const variantInput = document.getElementById('variant-id');
  if (variantInput) variantInput.value = sel.value;
  const isAvailable = opt.dataset.available === 'true';
  const atcBtn = document.querySelector('.atc-btn');
  if (atcBtn) {
    atcBtn.disabled = !isAvailable;
    atcBtn.textContent = isAvailable ? 'Add to cart' : 'Out of stock';
  }
  const url = new URL(window.location);
  url.searchParams.set('variant', sel.value);
  window.history.replaceState({}, '', url);
}

// ── COLOUR SELECTOR ──
function setColour(el, label) {
  document.querySelectorAll('.colour-dot').forEach(d => d.classList.remove('active'));
  el.classList.add('active');
  const colourLabelEl = document.getElementById('colour-label');
  if (colourLabelEl) colourLabelEl.textContent = '· ' + label;
}

// ── STICKY ATC: IntersectionObserver ──
(function () {
  const stickyAtc = document.getElementById('sticky-atc');
  const atcRow = document.querySelector('.atc-row');
  if (!stickyAtc || !atcRow) return;
  const obs = new IntersectionObserver(([entry]) => {
    stickyAtc.classList.toggle('hidden', entry.isIntersecting);
  }, { threshold: 0.1 });
  obs.observe(atcRow);
})();

// ── CART: AJAX add + open Horizon drawer ──
async function lneaAddToCart(btn) {
  const form = document.getElementById('product-form');
  if (!form) return;

  btn.disabled = true;
  const original = btn.textContent;
  btn.textContent = 'Adding…';

  try {
    const formData = new FormData(form);

    // Ask Shopify to re-render the cart drawer section and return it in the response
    const cartItemsEl = document.querySelector('cart-items-component[data-section-id]');
    const sectionId = cartItemsEl?.dataset.sectionId || 'cart-drawer-section';
    formData.append('sections', sectionId);

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    });
    if (!res.ok) throw new Error('add failed');

    const data = await res.json();

    // Patch the cart drawer DOM with the freshly rendered section
    if (data.sections?.[sectionId]) {
      const parser = new DOMParser();
      const newDoc = parser.parseFromString(data.sections[sectionId], 'text/html');
      const newInner = newDoc.querySelector('.cart-drawer__inner');
      const curInner = document.querySelector('.cart-drawer__inner');
      if (newInner && curInner) {
        // Copy className so cart-drawer--empty is removed when cart has items
        curInner.className = newInner.className;
        curInner.innerHTML = newInner.innerHTML;
      }
    }

    // Open the drawer
    const themeDrawer = document.querySelector('theme-drawer#cart-drawer');
    if (themeDrawer && typeof themeDrawer.open === 'function') {
      themeDrawer.open();
    }

    btn.textContent = 'Added!';
    setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1400);
  } catch {
    btn.textContent = original;
    btn.disabled = false;
    window.location.href = '/cart';
  }
}

// Wire main ATC button
(function () {
  const atcBtn = document.querySelector('.atc-btn');
  if (!atcBtn) return;
  atcBtn.addEventListener('click', (e) => {
    e.preventDefault();
    lneaAddToCart(atcBtn);
  });
})();

// Wire sticky ATC button
(function () {
  const stickyBtn = document.querySelector('.sticky-atc-btn');
  if (!stickyBtn) return;
  stickyBtn.addEventListener('click', () => lneaAddToCart(stickyBtn));
})();
